<template>
  <div class="hl-demand-box">
    <div class="hl-demand-banner-box">
      <div>
        <h2><img src="@/assets/img/cjLOGO.png" alt="cjLOGO" /> 供需联创</h2>
        <p>基于泛鸿蒙国产化联创场景孵化</p>
        <div class="hl-demand-banner-content">
          <div class="hl-demand-banner-notice">
            <img src="@/assets/img/2.0/demandggicon.png" alt="图片" />
            <vue-seamless-scroll
              :data="listData"
              :class-option="optionSingleHeight"
              class="seamless-warp"
            >
              <ul class="item">
                <li v-for="(item, index) in listData" :key="index">
                  <p class="hl-demand-banner-notice-list">
                    鸿联创供需专区正式上线啦～伴行政企数字化转型
                  </p>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div class="hl-demand-banner-form">
            <div class="hl-demand-banner-carousel">
              <a-carousel autoplay>
                <div
                  class="hl-demand-banner-carousel-list"
                  v-for="el in demandList"
                  :key="el.id"
                  @click="$router.push(`/demand/detail?id=${el.id}`)"
                >
                  <VImg :attachment-id="el.bannerCover" alt="封面" />
                  <p>{{ el.bannerText }}</p>
                </div>
              </a-carousel>
            </div>
            <div class="hl-demand-banner-form-content">
              <div class="hl-demand-banner-form-tag">
                <div
                  :class="{ active: demandType === '1' }"
                  @click="demandType = '1'"
                >
                  <p>我有需求</p>
                  <span>南北向国产化技术迁移</span>
                </div>
                <div
                  :class="{ active: demandType === '2' }"
                  @click="demandType = '2'"
                >
                  <p>我要方案</p>
                  <span>海量精选场景化创新方案</span>
                </div>
              </div>
              <a-form-model
                layout="inline"
                ref="ruleForm"
                :model="ruleForm"
                :rules="rules"
                :label-col="{ span: 7 }"
                :wrapper-col="{ span: 17 }"
                class="hl-demand-banner-form-model"
              >
                <div>
                  <a-form-model-item
                    ref="name"
                    :label="demandType === '1' ? '需求主题' : '方案主题'"
                    prop="name"
                  >
                    <a-input
                      v-model="ruleForm.name"
                      @blur="
                        () => {
                          $refs.name.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    ref="contactPerson"
                    label="提交人"
                    prop="contactPerson"
                  >
                    <a-input
                      v-model="ruleForm.contactPerson"
                      @blur="
                        () => {
                          $refs.contactPerson.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    ref="contactPhone"
                    label="联系电话"
                    prop="contactPhone"
                  >
                    <a-input
                      v-model="ruleForm.contactPhone"
                      @blur="
                        () => {
                          $refs.contactPhone.onFieldBlur();
                        }
                      "
                    >
                      <template slot="suffix">
                        <v-count-down
                          :trigger="() => sendMobileCode()"
                          :phone="ruleForm.contactPhone"
                          ref="countDown"
                        >
                          <template #default>获取验证码</template>
                          <template #loading="scope"
                            >{{ scope.seconds }}秒后重新发送</template
                          >
                        </v-count-down>
                      </template>
                    </a-input>
                  </a-form-model-item>
                  <a-form-model-item ref="code" label="短信验证码" prop="code">
                    <a-input
                      v-model="ruleForm.code"
                      @blur="
                        () => {
                          $refs.code.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </div>
                <div>
                  <a-form-model-item
                    ref="commitCompanyName"
                    label="所属单位"
                    prop="commitCompanyName"
                  >
                    <a-input
                      v-model="ruleForm.commitCompanyName"
                      @blur="
                        () => {
                          $refs.commitCompanyName.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    ref="demandDescribe"
                    label="咨询详情"
                    prop="demandDescribe"
                  >
                    <a-textarea
                      v-model="ruleForm.demandDescribe"
                      placeholder="200字以内"
                      :maxLength="200"
                      :rows="3"
                      @blur="
                        () => {
                          $refs.demandDescribe.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                  <a-form-model-item :wrapper-col="{ span: 14, offset: 7 }">
                    <a-button class="btn-red" @click="submitForm">
                      提交咨询
                    </a-button>
                  </a-form-model-item>
                </div>
              </a-form-model>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LcProject />
    <LcAchievement />
    <div class="hl-demand-service">
      <strong>优质服务商</strong>
      <div>
        <div v-for="(el, index) in storeList" :key="index">
          <VImg class="logo" :attachment-id="el.isvImg" alt="服务商" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import LcProject from "./components/project.vue";
import LcAchievement from "./components/achievement.vue";
import VCountDown from "@/components/VCountDown";
import { demandSave, getDemandPageList } from "@/api/demand";
import { sendMobile, checkCaptchaMobile } from "@/api/common";
import { getStorePageList } from "@/api/treasury.js";
import VImg from "@/components/VImg.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    vueSeamlessScroll,
    LcProject,
    LcAchievement,
    VCountDown,
    VImg,
  },
  data() {
    return {
      demandType: "1",
      listData: [
        {
          title: "无缝滚动第一行无缝滚动第一行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第二行无缝滚动第二行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第三行无缝滚动第三行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第四行无缝滚动第四行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第五行无缝滚动第五行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第六行无缝滚动第六行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第七行无缝滚动第七行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第八行无缝滚动第八行",
          date: "2017-12-16",
        },
        {
          title: "无缝滚动第九行无缝滚动第九行",
          date: "2017-12-16",
        },
      ],
      ruleForm: {
        contactPhone: "",
      },
      rules: {
        name: [{ required: true, message: "请输入需求主题", trigger: "blur" }],
        contactPerson: [
          { required: true, message: "请输入提交人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        commitCompanyName: [
          { required: true, message: "请输入所属单位", trigger: "blur" },
        ],
        demandDescribe: [
          { required: true, message: "请输入咨询详情", trigger: "blur" },
        ],
      },
      storeList: [],
      demandList: [],
    };
  },
  computed: {
    ...mapGetters(["tenant"]),
    optionSingleHeight() {
      return {
        singleHeight: 20,
      };
    },
  },
  mounted() {
    this.loadGetDemandPageList();
    this.loadGetStorePageList();
  },
  methods: {
    loadGetDemandPageList() {
      getDemandPageList({ current: 1, size: 10 }, { isRecommend: true }).then(
        (res) => {
          this.demandList = res.records;
        }
      );
    },
    loadGetStorePageList() {
      getStorePageList({ current: 1, size: 15 }, { isRecommend: true }).then(
        (res) => {
          this.storeList = res.records;
        }
      );
    },
    submitForm() {
      let _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          checkCaptchaMobile({
            mobile: _this.ruleForm.contactPhone,
            code: _this.ruleForm.code,
          }).then((res) => {
            if (!res) {
              _this.$message.warning("验证码有误");
              return;
            }
            _this.ruleForm.demandCreateType = _this.demandType;
            _this.ruleForm.demandSource = "1";
            _this.ruleForm.demandStatus = "2";
            _this.ruleForm.tenantId = _this.tenant.id;
            demandSave(_this.ruleForm).then(() => {
              // _this.$message.success("提交成功！");
              _this.$success({
                title: '提交成功',
                centered:true,
                // JSX support
                content: (
                    <div>
                      <p>等待联创技术专家联系</p>
                    </div>
                ),
              });
              _this.$refs.ruleForm.resetFields();
              _this.$refs.countDown.resetTime();
            });
          });
        }
      });
    },
    sendMobileCode() {
      const { contactPhone } = this.ruleForm;
      sendMobile(contactPhone).then(() => {
        this.$message.success("发送成功！");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hl-demand-box {
  background: #fff;
  .hl-demand-banner-box {
    background: url(../../assets/img/2.0/demandbanner-bg.jpg) no-repeat;
    background-size: 100% 100%;
    padding: 88px 0 33px;
    > div {
      width: 1280px;
      margin: 0 auto;
      > h2 {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 40px;
        color: #333333;
        line-height: 56px;
        margin-bottom: 16px;
        > img {
          margin-right: 12px;
        }
      }
      > p {
        font-size: 24px;
        color: #262626;
        line-height: 32px;
        margin-bottom: 88px;
      }
      .hl-demand-banner-notice {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        > img {
          margin-right: 8px;
        }
        .hl-demand-banner-notice-list {
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .hl-demand-banner-form {
        display: flex;
        justify-content: space-between;
        .hl-demand-banner-carousel {
          width: 528px;
          height: 298px;
          .hl-demand-banner-carousel-list {
            width: 528px;
            height: 298px;
            position: relative;
            cursor: pointer;
            > img {
              display: block;
              width: 100%;
              height: 100%;
            }
            > p {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              height: 40px;
              background: rgba(0, 0, 0, 0.6);
              line-height: 40px;
              font-size: 14px;
              color: #fff;
              z-index: 2;
              padding: 0 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .hl-demand-banner-form-content {
          .hl-demand-banner-form-tag {
            height: 72px;
            width: 560px;
            display: flex;
            align-items: flex-end;
            > div {
              flex: 1;
              text-align: center;
              background: linear-gradient(#ffffff 0%, #fff3f3 100%);
              border-radius: 0px 8px 0px 0px;
              padding: 12px 0;
              cursor: pointer;
              transition: all 0.3s;
              > p {
                font-size: 18px;
                color: #262626;
                line-height: 24px;
                margin-bottom: 0;
                transition: all 0.3s;
              }
              > span {
                display: block;
                font-size: 12px;
                color: #999999;
                line-height: 16px;
              }
              &.active {
                background: #ffffff;
                border-radius: 8px 8px 0px 0px;
                padding-top: 20px;
                > p {
                  font-weight: bold;
                }
              }
            }
          }
          .hl-demand-banner-form-model {
            background: #fff;
            width: 728px;
            padding: 28px 24px 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            > div {
              width: 48%;
              > div {
                width: 100%;
                margin: 0 0 4px 0;
              }
            }
            ::v-deep .ant-form-explain {
              display: none;
            }
            ::v-deep .ant-input-suffix {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.hl-demand-service {
  padding: 64px 0;
  width: 1280px;
  margin: 0 auto;
  > strong {
    display: block;
    font-weight: bold;
    font-size: 32px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-stroke: 1px #979797;
    margin-bottom: 40px;
    text-align: center;
  }
  > div {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      margin-top: 24px;
      > img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
.seamless-warp {
  height: 20px;
  overflow: hidden;
}
</style>
